import React from 'react'
import styled, { css } from 'styled-components'

interface StyledIconProps {
  icon: React.ReactNode
  fontSize?: string
  color?: string
  styles?: string
}

export function StyledIcon({ icon, fontSize, color, styles }: StyledIconProps) {
  return (
    <Wrap $fontSize={fontSize} $color={color} $styles={styles}>
      {icon}
    </Wrap>
  )
}

const Wrap = styled.span<{ $color?: string; $fontSize?: string; $styles?: string }>`
  line-height: 0;

  svg {
    ${(p) =>
      p.$color &&
      css`
        color: ${p.$color};
      `};

    ${(p) =>
      p.$fontSize &&
      css`
        font-size: ${p.$fontSize};
      `};

    ${(p) => p.$styles};
  }
`
